import { __assign, __rest } from "tslib";
import React from 'react';
import MaskedInput from '../masked-input';
import { daysInMonth, parseDate, displayToIso } from './utils/date';
function daysMax(value) {
    // force to first day in month, as new Date('2018-02-30') -> March 2nd 2018
    var baseDate = displayToIso(value).substring(0, 7);
    return daysInMonth(parseDate(baseDate));
}
var maskArgs = {
    separator: '/',
    inputSeparators: ['-', '.', ' '],
    segments: [
        { min: 0, max: 9999, "default": 2000, length: 4 },
        { min: 1, max: 12, length: 2 },
        { min: 1, max: daysMax, length: 2 },
    ]
};
var DateInput = React.forwardRef(function (_a, ref) {
    var _b = _a.__internalRootRef, __internalRootRef = _b === void 0 ? null : _b, props = __rest(_a, ["__internalRootRef"]);
    return (React.createElement(MaskedInput, __assign({}, props, { ref: ref, disableBrowserAutocorrect: true, mask: maskArgs, autofix: true, __internalRootRef: __internalRootRef })));
});
export default DateInput;
//# sourceMappingURL=index.js.map